// Companion wordmark — renders the brand SVG.
import wordmarkIndigo from "../assets/companion-wordmark-indigo.svg";

type WordmarkProps = {
  size?: number;
};

export function Wordmark({ size = 34 }: WordmarkProps) {
  return (
    <div className="flex items-center">
      <img
        src={wordmarkIndigo}
        alt="Companion"
        height={size}
        style={{ "--wm-h": `${size}px` } as React.CSSProperties}
        className="block h-[var(--wm-h)] w-auto"
      />
    </div>
  );
}
